// lib/realtimeLevel.js
// 실시간 HR 세션(체육관 맥 realtime_hr)에 보내는 회원 레벨.
//
// 계약: 실시간 세션 level은 1..5 정수다 (TV 순위표와 같은 5칸, R1 5절).
// cloudapi가 GET /v1/admin/members/{id}/dashboard의 level을 이미 1..5로 잘라서 준다
// (util.TVLevelForMinutes = min(5, 앱 레벨 1..20)). 앱 레벨 1..20은 이 응답에 오지 않는다.
//
// clampLevelForRealtime는 같은 계약을 admin-web에서 한 번 더 지키는 방어선이다.
// 서버 쪽이 바뀌어 6 이상이나 소수·문자열이 오더라도 체육관 맥에는 1..5 정수만 간다.
// 체육관 맥 Python이 구버전(level le=5)이면 6 이상이 한 명만 있어도
// session/start·add-participant·sync 요청 전체가 422가 되기 때문이다.
// TV는 5칸만 그리므로 잘라도 잃는 정보가 없다.

// 실시간 세션 레벨 상한 (cloudapi util.TVLevelMax와 같은 값).
export const REALTIME_LEVEL_MAX = 5;

// v를 1..REALTIME_LEVEL_MAX 정수로 바꾼다.
// 숫자가 아니거나 1 미만이면 1, 소수는 내림, 상한을 넘으면 REALTIME_LEVEL_MAX.
export function clampLevelForRealtime(v) {
  const n = Number(v);
  if (!Number.isFinite(n) || n < 1) return 1;
  return Math.min(REALTIME_LEVEL_MAX, Math.floor(n));
}
